var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 584,
    viewBox: "0 0 292 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5522_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.099 16.2536L35.5981 185.864C12.7498 210.518 -1.23211e-05 243.303 -1.09724e-05 277.4C-9.62374e-06 311.497 12.7498 344.281 35.5981 368.936L200.099 538.546C210.195 548.953 223.888 554.8 238.166 554.8C252.443 554.8 266.136 548.953 276.232 538.546C286.328 528.139 292 514.024 292 499.306C292 484.588 286.328 470.472 276.232 460.065L111.695 290.455C108.332 286.987 106.443 282.285 106.443 277.381C106.443 272.478 108.332 267.775 111.695 264.307L276.232 94.7343C286.328 84.3272 292 70.212 292 55.494C292 40.776 286.328 26.6608 276.232 16.2536C266.136 5.84642 252.443 -0.000210449 238.166 -0.000209869C223.888 -0.000209289 210.195 5.84642 200.099 16.2536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5522_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 584,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowChat);
export default __webpack_public_path__ + "static/media/arrow-chat.92edf2047352fd1a00c05dae91fe6923.svg";
export { ForwardRef as ReactComponent };